import PropTypes from "prop-types"
import Head from "next/head"
import {
  buildProductSchema,
  serializeJsonLd
} from "helpers/structuredData"

export default function Product({ car, url }) {
  const data = buildProductSchema(car, {
    url,
    cloudinaryBase: process.env.NEXT_PUBLIC_CLOUDINARY || "",
    aggregate: true
  })
  if (!data) return null

  return (
    <Head>
      {/* eslint-disable react/no-danger */}
      <script
        key={`renting-product-${car.id || url}`}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd({
            "@context": "https://schema.org",
            ...data
          })
        }}
      />
      {/* eslint-enable react/no-danger */}
    </Head>
  )
}

Product.propTypes = {
  car: PropTypes.object.isRequired,
  url: PropTypes.string.isRequired
}
